import React, { useMemo, useRef } from 'react'
import { IconButton } from '@material-ui/core'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'
import Icon from '../../../../../atoms/Icon'
import { useAccountFormContext } from '../../AccountFormProvider'
import { useCheckPolicy } from '../../../../../../hooks'
import { ACCOUNTS } from '../../../../../../policies/admin'
import { fsExcludeClass } from '../../../../../../utils/fsExclude'
import DisplayNumberDialog from './DisplayNumberDialog'

function DisplayNumberInput () {
  const { account } = useAccountFormContext()
  const dialogRef = useRef()
  const hasEditPolicy = useCheckPolicy(ACCOUNTS.editDisplayNumber)
  const canEditDisplayNumber = useMemo(() =>
    hasEditPolicy && !!account?.custodian?.[0]?.allowAccountDisplayNumberEdit,
  [hasEditPolicy, account])

  return (
    <>
      <SydLabel label='Display Number'>
        <div className='__control-group'>
          <SydInput disabled value={account.displayNumber} className={fsExcludeClass} />
          {canEditDisplayNumber ? (
            <div>
              <IconButton onClick={e => dialogRef.current.open(e)}>
                <Icon customSize={20} name='edit' />
              </IconButton>
            </div>
          ) : null}
        </div>
      </SydLabel>
      <DisplayNumberDialog ref={dialogRef} />
    </>
  )
}

DisplayNumberInput.propTypes = {}
export default DisplayNumberInput
